import type { z } from "@hono/zod-openapi";
import { onDriverRefs } from "../../refs";

/**
 * Driver-centric: an hours-of-service timer runs against a person and names no vehicle.
 */
export const hosClockViolationRefs = { ...onDriverRefs };

export type HosClockViolationRefs = z.infer<z.ZodObject<typeof hosClockViolationRefs>>;
